var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"logo",class:{ mobile: _vm.$mq === 'sm' || _vm.$mq === 'md' },attrs:{"src":_vm.src,"alt":"Cafe Glocksee"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }